import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServerCustomCss, ClientCustomCss } from './customCss'
import { LifeCycle } from '@wix/thunderbolt-symbols'

export const site: ContainerModuleLoader = (bind) => {
	if (!process.env.browser) {
		bind(LifeCycle.AppWillMountHandler).to(ServerCustomCss)
	} else {
		bind(LifeCycle.AppWillMountHandler).to(ClientCustomCss)
	}
}

export { CustomCssAPI } from './ds/customCssAPI'
export { CustomCssAPISymbol } from './symbols'
export type { ICustomCssAPI } from './types'
